

























import Component from 'vue-class-component'
import Vue from 'vue'
import Icon from '@/components/Icon.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Card from '@/components/Card.vue'

@Component({
  components: { Card, LoaderWrapper, Icon },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Boolean,
      default: false
    },
    opened: {
      type: Boolean,
      default: true
    }
  }
})
export default class TabsV3 extends Vue {
  isSidebarOpened: boolean = this.$props.opened

  mounted () {
    if (this.$props.toggle) {
      this.watchWW()
      window.addEventListener('resize', this.watchWW)
    }
  }

  beforeDestroy () {
    if (this.$props.toggle) {
      window.removeEventListener('resize', this.watchWW)
    }
  }

  watchWW () {
    // @ts-ignore
    this.toggleSidebar(window.innerWidth > 1920)
  }

  toggleSidebar (value: boolean | null = null) {
    this.isSidebarOpened = value !== this.isSidebarOpened && value === null
      ? !this.isSidebarOpened
      : value
    this.$emit('toggle', this.isSidebarOpened)
    setTimeout(() => this.$eventBus.$emit('resize'), 200)
  }
}
